import HiddenInput from 'components/Common/Form/Input/HiddenInput'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Divider from 'components/Luxkit/Divider'
import Dropdown from 'components/Luxkit/Dropdown/v2/Dropdown'
import DropdownContainer from 'components/Luxkit/Dropdown/DropdownContainer'
import Caption from 'components/Luxkit/Typography/Caption'
import SearchFormTextField from 'components/SearchV2/Components/SearchFormField/SearchFormTextField'
import React from 'react'
import RecentSearchSuggestions from '../SearchForm/SearchLocationInput/RecentSearchSuggestions'
import SearchMenuListItem from '../SearchForm/SearchMenu/SearchMenuListItem'
import SearchPlaceSelectList from './SearchPlaceSelectList'
import styled from 'styled-components'

const PlaceControl = styled.div`
  position: relative;
  width: 100%;
`

interface Props {
  className?: string;
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  value?: App.SearchItem;
  required?: boolean;
  label: string;
  placeholder: string;
  localInputRef: React.RefObject<HTMLInputElement>;
  searchPhrase: string;
  onSearchPhraseChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleOpen: (e: any) => void;
  onClearClick: () => void;
  finalOpen: boolean;
  closeDropdown: () => void;
  showPlaceholder: boolean;
  hasRecentSearchItems: boolean;
  recentSearches: Array<App.FullRecentSearch>;
  selectedDropdown: number | undefined;
  onRecentSearchDelete: (item: App.FullRecentSearch) => void;
  onRecentSearchClick: (item: App.FullRecentSearch) => void;
  placeholderTitle?: string;
  placeholdersSearches: Array<App.SearchItem>;
  onLocationSelect: (item?: App.SearchItem) => void;
  handleResultsChange: (results: Array<App.SearchItem>, searchPhrase: string) => void;
  placeTypes?: Array<App.SearchPlaceType>;
  searchTypes?: Array<App.SearchType>;
  searchVertical?: App.SearchPlaceVertical;
  overrideSearchItems?: Array<App.SearchItem>;
}

function SearchPlaceSelectDropdown(props: Props) {
  const {
    className,
    onKeyDown,
    value,
    required,
    label,
    placeholder,
    localInputRef,
    searchPhrase,
    onSearchPhraseChange,
    handleOpen,
    onClearClick,
    finalOpen,
    closeDropdown,
    showPlaceholder,
    hasRecentSearchItems,
    recentSearches,
    selectedDropdown,
    onRecentSearchDelete,
    onRecentSearchClick,
    placeholderTitle,
    placeholdersSearches,
    onLocationSelect,
    handleResultsChange,
    placeTypes,
    searchTypes,
    searchVertical,
    overrideSearchItems,
  } = props
  return (
    <PlaceControl className={className} onKeyDown={onKeyDown}>
      <HiddenInput
      required={required}
      value={value?.format.mainText}
    />
      <SearchFormTextField
      label={label}
      placeholder={placeholder}
      ref={localInputRef}
      value={searchPhrase}
      displayValue={value?.format.mainText ?? ''}
      onChange={onSearchPhraseChange}
      onFocus={handleOpen}
      onClear={onClearClick}
    />
      <Dropdown
      open={finalOpen}
      triggerRef={localInputRef}
      floatingStrategy="absolute"
      width="100%"
      disableFlip
      onClose={closeDropdown}
    >
        <DropdownContainer>
          {showPlaceholder && <VerticalSpacer gap={12}>
            {hasRecentSearchItems && <>
              <RecentSearchSuggestions
              recentSearches={recentSearches}
              onDelete={onRecentSearchDelete}
              selectedDropdown={selectedDropdown}
              onRecentSearchClick={onRecentSearchClick}
            />
              <Divider kind="primary" />
            </>}
            <div>
              {placeholderTitle && <Caption variant="large" weight="bold">{placeholderTitle}</Caption>}
              {placeholdersSearches.map((item, index) => <SearchMenuListItem
              key={item.value}
              searchItem={item}
              onClick={onLocationSelect}
              selected={index + recentSearches.length === selectedDropdown}
            />)}
            </div>
          </VerticalSpacer>}
          {!showPlaceholder &&
            <SearchPlaceSelectList
              searchPhrase={searchPhrase}
              onResultsChange={handleResultsChange}
              onChange={onLocationSelect}
              placeTypes={placeTypes}
              searchTypes={searchTypes}
              vertical={searchVertical}
              selectedDropdown={selectedDropdown}
              overrideSearchItems={overrideSearchItems}
            />}
        </DropdownContainer>
      </Dropdown>
    </PlaceControl>
  )
}

export default SearchPlaceSelectDropdown
